import Vue from 'vue'
import Router from 'vue-router'
import goaltracking from '@/components/attendanceemployee'
import settings from '@/views/settings/profile'
import settings_billing from '@/views/settings/billing'

// import profile from '@/components/profile'
// import clientprofile from '@/components/clientprofile'
import error404 from '@/components/error404'
import error500 from '@/components/error500'
import employeeslist from '@/components/employeeslist'
import index from '@/views/dashboard/index'
import employeedashboard from '@/views/dashboard/employeedashboard'
import employees from '@/components/employees'
import invoices from '@/components/invoices'
import tickets from '@/components/tickets'
import faq from '@/views/page/faq'
import terms from '@/views/page/terms'
import privacypolicy from '@/components/privacypolicy'

import changepassword from '@/components/changepassword'
import localization from '@/views/settings/localization'
import loginPage from './modules/login'

import apps from "./modules/apps";
import register from "@/views/register";
import otpConfirm from "@/views/register/confirm";
import forgotRequest from "@/views/forgot";
import forgotCheck from "@/views/forgot/check";
import licenseList from '@/views/license/list'
import licenseSummary from '@/views/license/summary'
import licenseInfo from '@/views/license/info'
import agentConnect from '@/views/agentconnect'

import agentList from '@/views/agent/list'
import agentRoles from '@/views/agent/roles'
import agentTasks from '@/views/agent/tasks'
import monthlyAgentsStatistic from '@/views/agent/statisticMonthly'

import messageReportOutbox from '@/views/messageReport/outbox'
import messageReportInbox from '@/views/messageReport/inbox'
import messageReportReplyButtons from '@/views/messageReport/reply-buttons'
import messageReportReplyButtonsDetail from '@/views/messageReport/reply-buttons-detail'
import messageReportSmartReply from '@/views/messageReport/smart-reply'
import messageReportSmartReplyDetail from '@/views/messageReport/smart-reply-detail'

import orderList from '@/views/order/list'
import orderListActiveVoucher from '@/views/order/active_voucher'

import binanceView from '@/views/binance/index'
// import contacts from '@/components/contacts'
import contacts from '@/views/contacts/list'
import importContacts from '@/views/contacts/import-contact'
import syncWhatsappContacts from '@/views/contacts/sync-contact'

import referral from '@/views/referral/index'
import referralLink from '@/views/referral/link'
import referralCommission from '@/views/referral/commission'
import referralFaq from '@/views/referral/faq'


import messageReportBroadcast from '@/views/messageReport/broadcast'
import messageReportBroadcastWizard from '@/views/broadcast/wizard'

import memberList from '@/views/member/list'
import memberActiveLicense from '@/views/member/active-lisence.vue'
import memberReseller from '@/views/member/reseller.vue'
import memberSaldoReseller from '@/views/member/saldoReseller.vue'
import memberDownline from '@/views/member/downline.vue'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/redirect',
    hidden: true,
    children: [{
      path: '/redirect/:path*',
      component: () => import('@/views/redirect/index')
    }]
  },
  {
    path: '/register',
    name: 'register',
    meta: {
      title: 'Registration',
    },
    hidden: false,
    // component: register,
    component: () => import("@/views/subscriptions/index"),
  },
  {
    path: '/register/confirm',
    name: 'otpConfirm',
    meta: {
      title: 'Registration OTP',
    },
    hidden: false,
    component: otpConfirm,
  },
  {
    path: '/forgotpassword',
    name: 'forgotpassword',
    meta: {
      title: 'Forgot Password',
    },
    hidden: false,
    component: forgotRequest,
  },
  {
    path: '/forgotpassword/check',
    name: 'forgotpasswordcheck',
    meta: {
      title: 'Forgot Password',
    },
    hidden: false,
    component: forgotCheck,
  },
  loginPage,
  {
    path: '/error404',
    name: 'error404',
    hidden: true,
    component: error404,
  },
  {
    path: '/error500',
    name: 'error500',
    hidden: true,

    component: error500,
  },
  {
    path: '/sign-agent',
    meta: {
      title: 'Sign Agent',
    },
    name: 'sign-agent',
    component: () => import("@/views/login/agent"),
  },
  {
    path: '/subscriptions',
    name: 'subscriptions',
    component: () => import("@/views/subscriptions/index"),
  },
  {
    path: '/order',
    name: 'order',
    component: () => import("@/views/subscriptions/orderForm"),
  },
  {
    path: '/order-finish',
    name: 'order_finish',
    component: () => import("@/views/subscriptions/orderFinish"),
  },
  {
    path: '/terms',
    name: 'terms',
    component: terms,
  },
  // // chat,
  // {
  //   path: "*",
  //   redirect: "/404",
  //   hidden: true
  // }
];
//   ,
//   linkActiveClass: "active",
// })

export const asyncRoutes = [
  /** when your routing map is too long, you can split it into small modules **/
  // 404 page must be placed at the end !!!
  {
    hidden: false,
    meta: {
      title: 'Message Broadcast'
    },
    path: '/message_report/broadcast/wizard',
    name: 'message_report_broadcast_wizard',
    component: messageReportBroadcastWizard,
  },
  {
    hidden: false,
    meta: {
      title: 'Affiliate Program',
      roles: ['member']
    },
    path: '/referral',
    name: 'referral',
    component: referral,
  },
  {
    hidden: false,
    meta: {
      title: 'Share Link - Affiliate Program',
      roles: ['member']
    },
    path: '/referral/link',
    name: 'referral_link',
    component: referralLink,
  },
  {
    hidden: false,
    meta: {
      title: 'Commission - Affiliate Program',
      roles: ['member']
    },
    path: '/referral/commission',
    name: 'referral_commission',
    component: referralCommission,
  },
  {
    hidden: false,
    meta: {
      title: 'Faq - Affiliate Program',
      roles: ['member']
    },
    path: '/referral/faq',
    name: 'referral_faq',
    component: referralFaq,
  },
  {
    path: '/omni/connect-to-agent-owner',
    name: 'connect-to-agent-owner',
    hidden: true,
    component: agentConnect,
  },
  {
    path: '/faq',
    name: 'faq',
    hidden: false,
    component: faq,
  },

  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    hidden: false,
    component: privacypolicy,
  },
  {
    hidden: false,
    path: '/contacts',
    name: 'contacts',
    meta: {
      title: 'Contacts',
      // roles: ['member']
    },
    component: contacts,
  },
  {
    hidden: false,
    path: '/contacts/import-contacts',
    name: 'importContacts',
    component: importContacts,
  },
  {
    hidden: false,
    path: '/contacts/sync-contacts',
    name: 'syncContacts',
    component: syncWhatsappContacts,
  },
  {
    hidden: false,
    meta: {
      title: 'License List',
      roles: ['member']
    },
    path: '/license/list',
    name: 'license',
    component: licenseList,
  },
  {
    hidden: false,
    meta: {
      title: 'Licenses Summary',
      roles: ['member']
    },
    path: '/license/summary',
    name: 'licenses_summary',
    component: licenseSummary,
  },
  {
    hidden: true,
    meta: {
      title: 'License Info',
      roles: ['member']
    },
    path: '/license/info',
    name: 'license_info',
    component: licenseInfo,
  },
  {
    hidden: false,
    meta: {
      title: 'All Agents',
      roles: ['member']
    },
    path: '/agent/list',
    name: 'agentList',
    component: agentList,
  },
  {
    hidden: false,
    meta: {
      title: 'Agent Roles',
      roles: ['member']

    },
    path: '/agent/roles',
    name: 'agentRoles',
    component: agentRoles,
  },
  {
    hidden: false,
    meta: {
      title: 'Agent Tasks',
      roles: ['member']
    },
    path: '/agent/tasks',
    name: 'agent_tasks',
    component: agentTasks,
  },
  {
    hidden: false,
    meta: {
      title: 'Monthly Agents Statistic',
      roles: ['member']
    },
    path: '/agent/monthly_agents_statistics',
    name: 'monthly_agents_statistics',
    component: monthlyAgentsStatistic,
  },
  {
    hidden: true,
    meta: {
      title: 'Smart Reply Detail',
      roles: ['member']
    },
    path: '/message_report/smart_reply_detail',
    name: 'message_report_smart_reply_detail',
    component: messageReportSmartReplyDetail,
  },
  {
    hidden: false,
    meta: {
      title: 'Smart Reply',
      roles: ['member']
    },
    path: '/message_report/smart_reply',
    name: 'message_report_smart_reply',
    component: messageReportSmartReply,
  },
  {
    hidden: true,
    meta: {
      title: 'Reply Buttons Detail',
      roles: ['member']
    },
    path: '/message_report/reply_buttons_detail',
    name: 'message_report_reply_buttons_detail',
    component: messageReportReplyButtonsDetail,
  },
  {
    hidden: false,
    meta: {
      title: 'Reply Buttons',
      roles: ['member']
    },
    path: '/message_report/reply_buttons',
    name: 'message_report_reply_buttons',
    component: messageReportReplyButtons,
  },
  {
    hidden: false,
    meta: {
      title: 'Message Outbox',
      roles: ['member']
    },
    path: '/message_report/outbox',
    name: 'message_report_outbox',
    component: messageReportOutbox,
  },
  {
    hidden: false,
    meta: {
      title: 'Message Inbox',
      roles: ['member']
    },
    path: '/message_report/inbox',
    name: 'message_report_inbox',
    component: messageReportInbox,
  },
  {
    hidden: false,
    meta: {
      title: 'Message Broadcast'
    },
    path: '/message_report/broadcast',
    name: 'message_report_broadcast',
    component: messageReportBroadcast,
  },
  {
    hidden: false,
    meta: {
      title: 'Order List',
      roles: ['member']
    },
    path: '/order/list',
    name: 'order_list',
    component: orderList,
  },
  {
    hidden: false,
    meta: {
      title: 'Active Voucher',
      roles: ['member']
    },
    path: '/order/active_voucher',
    name: 'active_voucher',
    component: orderListActiveVoucher,
  },
  {
    hidden: false,
    path: '/goaltracking',
    name: 'goaltracking',
    component: goaltracking,
  },
  {
    path: '/',
    name: 'index',
    component: index,
  },
  {
    path: '/index',
    hidden: false,
    name: 'indexs',
    component: index,
  },
  {
    hidden: false,
    path: '/employeedashboard',
    name: 'employeedashboard',
    component: employeedashboard,
  },
  {
    hidden: false,
    path: '/employees',
    name: 'employees',
    component: employees,
  },
  {
    hidden: false,
    path: '/tickets',
    name: 'tickets',
    component: tickets,
  },
  {
    hidden: false,
    meta: {
      title: 'Settings',
      roles: ['member']
    },
    path: '/settings',
    name: 'settings',
    component: settings,
  },
  {
    hidden: false,
    meta: {
      title: 'Bank',
      roles: ['member']
    },
    path: '/settings/billing',
    name: 'settings_billing',
    component: settings_billing,
  },
  {
    hidden: false,
    meta: {
      title: 'Change Password',
      roles: ['member']
    },
    path: '/changepassword',
    name: 'changepassword',
    component: changepassword,
  },
  {
    meta: {
      title: 'Localization',
      roles: ['member']
    },
    hidden: false,
    path: '/localization',
    name: 'localization',
    component: localization,
  },
  {
    meta: {
      title: 'Invoices',
      roles: ['member']
    },
    hidden: false,
    path: '/invoices',
    name: 'invoices',
    component: invoices,
  },
  {
    hidden: false,
    meta: {
      title: 'Daftar Member',
      roles: ['member']
    },
    path: '/member/list',
    name: 'member',
    component: memberList,
  },
  {
    hidden: false,
    meta: {
      title: 'Lisensi Aktif',
      roles: ['member']
    },
    path: '/member/active-lisence',
    name: 'member_active_lisence',
    component: memberActiveLicense,
  },
  {
    hidden: false,
    meta: {
      title: 'Daftar Reseller',
      roles: ['member']
    },
    path: '/member/reseller',
    name: 'member_reseller',
    component: memberReseller,
  },
   {
    hidden: false,
    meta: {
      title: 'Saldo Reseller',
      roles: ['member']
    },
    path: '/member/saldo/reseller',
    name: 'member_saldo_reseller',
    component: memberSaldoReseller,
  },
  {
    hidden: false,
    meta: {
      title: 'Daftar Downline',
      roles: ['member']
    },
    path: '/member/downline',
    name: 'member_downline',
    component: memberDownline,
  },
  // {
  //   meta: {
  //     title: 'Profile',
  //     roles: ['member']
  //   },
  //   hidden: false,
  //   path: '/profile',
  //   name: 'profile',
  //   component: profile,
  // },
  // {
  //   hidden: false,
  //   path: '/clientprofile',
  //   name: 'clientprofile',
  //   component: clientprofile,
  // },
  {
    hidden: false,
    path: '/employeeslist',
    name: 'employeeslist',
    component: employeeslist,
  },
  {
    hidden: false,
    path: '/binance',
    name: 'binance',
    component: binanceView,
  },
  {
    hidden: false,
    path: '/binance/order',
    name: 'binance-order',
    component: () => import('@/views/binance/order')
  },
  {
    hidden: false,
    path: '/binance/buysell',
    name: 'binance-buysell',
    component: () => import('@/views/binance/buysell')
  },
  apps,
  // { path: "*", component: () => error404, }

  {
    path: "*",
    redirect: "/error404",
    hidden: true
  }
];

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes,
    linkActiveClass: "active",
  });


const router = createRouter();

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GANALYTICS,
  },
}, router);

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// export default router;
export default router


// WEBPACK FOOTER //
// ./src/router/index.js